import React  from "react"
import styled from "styled-components/macro";

const TablesWrapView = ({tablesList, onTableClick}) => {

    const _renderTables = ()=>{
        return tablesList?.map?.((item, index)=>{
            return <Button onClick={()=>{
                onTableClick(item)}
            } key={index}>{item}</Button>
        });
    }

    return <Wrapper>{_renderTables()}</Wrapper>
}

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

const Button = styled.div`
  display: flex;
  padding: 5px 10px;
  border-radius: 4px;
  border: 1px solid #707070;
  margin:  5px 10px;
  cursor: pointer;
  box-shadow: 2px 2px 5px #bababa;
`;

export {TablesWrapView}